<template>
  <div class="view following-view">
    <HeaderBar />
    <ul class="following-list" v-if="list.length > 0">
      <li
        class="following-item"
        v-for="item in list"
        :key="item.friend_uid"
        @click="onFollowingClick(item.friend_uid)"
      >
        <img class="avatar-img" :src="item.avatar" />
        <div class="info-wrap">
          <div class="title-wrap">
            <span class="title">{{ item.nickname }}</span>
            <span class="tag--small" @click.stop.prevent="onUnfollowClick(item.id)">
              取消关注
            </span>
          </div>
          <span class="text--sub">{{ item.introduction }}</span>
        </div>
      </li>
    </ul>
    <div class="no-content" v-else>————    暂无关注    ————</div>
  </div>
</template>
<script>
import { Dialog } from 'vant'
import apiUtil from '../../utils/apiUtil';
import apiConst from '../../consts/apiConst';
import HeaderBar from '../../components/HeaderBar';
export default {
  name: 'following',
  components: {
    HeaderBar,
    Dialog
  },
  data() {
    return {
      list: [],
      page: 1,
      pagesize: 10
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init(page = 1) {
      const res = await apiUtil.post(apiConst.getFollowing, {
        page,
        pagesize: this.pagesize
      });
      if (res.success) {
        this.list = res.list;
      }
    },

    onFollowingClick(id) {
      this.$router.push({
        name: 'userCenter',
        query: {
          action_id: id
        }
      });
    },

    onUnfollowClick(id){
      Dialog.confirm({
				title: '提示',
				message: '确定要取消关注该用户吗？'
			})
				.then(async () => {
					const res = await apiUtil.post(apiConst.submitUnfollow, {
            id
          });
					if (res.success) {
						this.list = this.list.filter(ele=>ele.id !== id);
					}
				})
				.catch(() => { });
    }
  }
};
</script>
<style lang="stylus" scoped>
.following-view{
  .following-list {
    padding: 30px 15px;

    .following-item {
      height: 160px;
      padding: 0 15px
      border-bottom: 1PX solid #F1F1F1
      display flex;
      align-items center

      .avatar-img{
        display: inline-block
        width: 90px
        height: 90px
        border-radius: 50%
        margin-right: 30px
      }

      .title-wrap {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .title {
          font-size: 32px
          margin-right: 25px;
        }
        .tag--small {
          border-radius: 8px;
          background-color: #eee;
          padding:8px 10px;
          color: #999;
          font-size: 24px;
        }
      }

      
    }
  }
  .no-content {
    height: 90px;
    line-height: 90px;
    color: #999;
    text-align: center;
  }
}
</style>
